module.exports = __webpack_public_path__ + "img/magazin_delo_about_us_1.c1ba95b7.jpg";